import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../api/authContext";

export default function Login() {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        const success = await login(email, password);

        setLoading(false);

        if (success) {
            setMessage("Connexion réussie");
            navigate("/dashboard", { replace: true });
        } else {
            setError("Email ou mot de passe incorrect");
        }
    };

    const handleForgotPassword = () => {
        alert("à faire");
    };

    return (
        <div className="container mx-auto max-w-md mt-20 p-6 bg-white text-black border rounded shadow">
            <h1 className="text-2xl font-bold mb-6 text-center">Connexion</h1>

            <form onSubmit={handleLogin} className="space-y-4">
                <div>
                    <label className="block mb-1 font-medium">Email</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full border p-2 rounded"
                        required
                    />
                </div>

                <div>
                    <label className="block mb-1 font-medium">Mot de passe</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full border p-2 rounded"
                        required
                    />
                </div>

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
                >
                    {loading ? "Connexion..." : "Se connecter"}
                </button>
            </form>

            {message && (
                <div className="mb-4 p-2 my-4 bg-green-100 text-green-700 rounded">
                    {message}
                </div>
            )}

            {error && (
                <div className="mb-4 p-2 my-4 bg-red-100 text-red-700 rounded">
                    {error}
                </div>
            )}

            <div className="mt-4 text-center">
                <button
                    onClick={handleForgotPassword}
                    className="text-blue-500 hover:underline text-sm"
                    disabled={loading}
                >
                    Mot de passe oublié ?
                </button>
            </div>
        </div>
    );
}
